import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "utils";

export const importUser = createAsyncThunk('importUser', async ({ values }) => {

    var bodyFormData = new FormData()

    bodyFormData.append("premise_id", values.premise_id)

    if (values.file) {
        bodyFormData.append("onboarding_file", values.file)
    }

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'onboarding_import',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "onboarding_file", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})